import React from "react";
import { Modal } from "react-bootstrap";
import { T } from "react-translator-component";
import ReviewFlowForm from "./ReviewFlowForm";
import { REVIEW_SETTING_TYPES } from "./Reviews/reviewQuestionBlocks";

const RateExtraQuestions = ({
  ratingId,
  reviewFlow,
  reviewSettingType = REVIEW_SETTING_TYPES.FLOW,
  setShowExtraQuestionsModal,
  showExtraQuestionsModal,
  language,
  onRate,
  settingId,
  roomOccupationId,
}) => {
  const handleDismiss = () => setShowExtraQuestionsModal(false);
  const handleFinish = () => {
    setShowExtraQuestionsModal(false);
    if (onRate) onRate();
  };

  return (
    <Modal show={showExtraQuestionsModal} onHide={handleDismiss} centered backdrop="static">
      <Modal.Header closeButton>
        <div className="w-100 p-2 mt-8">
          <h5>{T("review.extra_rate")}</h5>
          <p className="text-muted mt-2 mb-0 font-weight-light">{T("review.extra_rate_text")}</p>
        </div>
      </Modal.Header>
      <Modal.Body className="p-0">
        {ratingId ? (
          <ReviewFlowForm
            ratingId={ratingId}
            reviewFlow={reviewFlow}
            reviewSettingType={reviewSettingType}
            language={language}
            settingId={settingId}
            roomOccupationId={roomOccupationId}
            layout="embedded"
            onFinish={handleFinish}
            onDismiss={handleDismiss}
          />
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default RateExtraQuestions;
